import React, { Component, PropTypes } from 'react';
import { init } from './../landing-page.js';
import { sessionKey, lastProduct } from './../store/cookies.js';
import { basePathname, replace } from './../store/history.js';
import { fetchJson } from './../core/ajax-json.js';

class Home extends Component {
	componentWillMount() {
		if (sessionKey() || lastProduct()) {
			fetchJson('/site')
				.then((response) => {
					const defaultPath = response.result.toLowerCase();
					location.pathname = basePathname(defaultPath);
				});
		} else {
			init();
		}
	}

	render() {
		return (
			<div id="home" />
		);
	}
}

Home.propTypes = {
	router: PropTypes.object
};

export default Home;



// WEBPACK FOOTER //
// ./mobile-core/src/components/home.js